import dynamic from 'next/dynamic';
import { BlockProps } from '../BlockProps';
import { IFaqBlockData } from './IFaqBlockData';

export const DynamicFaqBlock = dynamic<BlockProps<IFaqBlockData>>(() =>
    import('./faqBlock').then(md => md.FaqBlock),
);
